import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";

import { getCurrentUser } from "../service/authService";

interface UserContextType {
  user: { username: string; role: string } | null;
  setUser: (user: { username: string; role: string } | null) => void;
  loggedInuser: string | null;
  sessiontoken: string | null;
  currentSessionAY: string | null;
  setLoggedInUser: (user: any) => void;
  setSessionToken: (token: any) => void;
  setCurrentSessionAY: (ay: any) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<{ username: string; role: string } | null>(
    getCurrentUser()
  );

  useEffect(() => {
    setUser(getCurrentUser()); // Initialize user from local storage
  }, []);

  const [loggedInuser, setLoggedInUser] = useState<any>(null);
  const [sessiontoken, setSessionToken] = useState<string | null>(null);
  const [currentSessionAY, setCurrentSessionAY] = useState<string | null>(() =>
    localStorage.getItem("selected_academic_records")
  );

  useEffect(() => {
    if (currentSessionAY) {
      localStorage.setItem("selected_academic_records", currentSessionAY);
    } else {
      localStorage.removeItem("selected_academic_records");
    }
  }, [currentSessionAY]);

  return (
    <UserContext.Provider
      value={{
        user,
        loggedInuser,
        sessiontoken,
        currentSessionAY,
        setLoggedInUser,
        setSessionToken,
        setCurrentSessionAY,
        setUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useApi = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error("useApi must be used inside ApiProvider");
  return context;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
